import { AssetEvent } from './asset.event';
import { EventRegistry } from '../../../../../domain/event/event.registry';
export class AssetArchivedEvent extends AssetEvent {
    constructor(payload, metadata, fromPersistence) {
        super({
            subject: `asset-class/${payload.assetClassId}/asset/${payload.id}`,
            type: AssetArchivedEvent.type,
            payload,
            metadata,
            fromPersistence,
        });
    }
}
AssetArchivedEvent.type = 'com.treeplotter.api.asset.archived.v1';
EventRegistry.register(AssetArchivedEvent.type, AssetArchivedEvent);
//# sourceMappingURL=asset-archived.event.js.map